import React from 'react';
import { Page } from '../Page';
const collageImages = ['https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&q=70', 'https://cdn.magicpatterns.com/uploads/wpmJem8TDq4uTdC2Nk1R42/618820481_18125169400552839_4998556993096379336_n.jpg', 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&q=70', 'https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=400&q=70', 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=400&q=70', 'https://cdn.magicpatterns.com/uploads/trmyzxT7gGMiHEqKGydQyv/615938090_18081177796965646_3507185526629023982_n.jpg', 'https://images.unsplash.com/photo-1547592180-85f173990554?w=400&q=70', 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400&q=70', 'https://cdn.magicpatterns.com/uploads/aPvpJpC6db6KY2BRCQTVNT/620509937_18131320030506803_144782265458598508_n.jpg', 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&q=70', 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400&q=70', 'https://cdn.magicpatterns.com/uploads/kiTpUwEkzUdsyvmpKR11cY/627172515_18336665800208534_7795684121705742258_n.jpg'];
export function PageAboutAuthor2() {
  return <Page hideFooter variant="dark" data-id="element-734">
      <div className="absolute inset-0" data-id="element-735">
        {/* Photo Collage Grid */}
        <div className="grid grid-cols-4 grid-rows-3 w-full h-full" data-id="element-736">
          {collageImages.map((src, i) => <div key={i} className="overflow-hidden" data-id="element-737">
              <img src={src} alt="" className={`w-full h-full object-cover ${i === 1 ? 'object-[25%_center]' : ''}`} data-id="element-738" />
            </div>)}
        </div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-charcoal/85" data-id="element-739" />

        {/* Centered Text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-20" data-id="element-740">
          <p className="text-[10px] font-bold text-[#9A9A90] uppercase tracking-[0.25em] mb-4" data-id="element-741">
            About the Author
          </p>

          <h1 className="text-5xl font-serif text-[#F5F5F0] leading-tight mb-3" data-id="element-742">
            Jack Achenbach
          </h1>

          <p className="text-xs text-[#D8D8D0] uppercase tracking-[0.2em] mb-10" data-id="element-743">
            MS, RDN, CPT
          </p>

          <div className="w-12 h-0.5 bg-tealslate mb-10" data-id="element-744" />

          <div className="space-y-5 text-sm text-[#D8D8D0] leading-[1.8] max-w-md" data-id="element-745">
            <p data-id="element-746">
              Jack Achenbach is a Registered Dietitian Nutritionist and
              Certified Personal Trainer specializing in metabolic health and
              sustainable weight management.
            </p>
            <p data-id="element-747">
              With extensive experience helping clients navigate the
              complexities of GLP-1 medications, Jack developed this framework
              to bridge the gap between medical intervention and practical,
              everyday nutrition.
            </p>
            <p data-id="element-748">
              His approach focuses on protecting muscle mass, optimizing
              nutrient intake, and building habits that outlast the
              prescription.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}